import { Typography } from '@mui/material';
import EscoDataGrid from '../../Controls/EscoGrid/EscoDataGrid';
//import LeyendaView from './LeyendaView';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../Context/AuthContext';
import { useLocation } from 'react-router-dom';
import ConfigMicroservicioParamView from './ConfigMicroservicioParamView';
import { getMicroserviciosParamList } from '../../../Service/microservicioService';

export default function ConfigMicroserviciosParam() {

    const { state } = useLocation();

    // Accede a los parámetros
    const pCodServicio = state?.CodServicio;
    const pCodInterfaz = state?.CodInterfaz;
    const pDescInterfaz = state?.DescInterfaz

    //const [data, setData] = useState([]);
    const [params, setParams] = useState([]);

    const [loading, setLoading] = useState(false);
    const { accessToken } = useContext(AuthContext);
    const { tokenExpiration, getAccessToken } = useContext(AuthContext);
    const [rowSelectd, setRowSelectd] = useState("Hola");


    const init = () => {

        getAccessToken()
            .then((token) => {
                setLoading(true);
                getMicroserviciosParamList(token, pCodServicio, pCodInterfaz)
                    .then((data) => {
                        setParams(data);
                        setLoading(false)

                    })
                    .catch()
                    .finally(() => setLoading(false));



            }
            )
    }

    useEffect(() => {
        init();
    }, [])

    const columns = [
        { field: 'Descripcion', headerName: 'Parámetro', width: 400, flex: 1 },
        { 
            field: 'Valor', 
            headerName: 'Valor', 
            width: 900, 
            flex: 1,
            renderCell: (params) => {
                return params.value;
            }
        }
    ];

    const rows = params

    function setData(data) {
        setParams(params.concat({
            CodServicio: data.CodServicio,
            CodParametroInt: data.CodParametroInt,
            CodInterfazServ: data.CodInterfazServ,
            CodTpActiveX: data.CodTpActiveX,
            CodTpDato: data.CodTpDato,
            Descripcion: data.Descripcion,
            Observaciones: data.Observaciones,
            TpValor: data.TpValor,
            Valor:  data.Valor
        })
    )    

    }


    function getRowId(row) {
        return row.CodParametroInt
    }

    return (
        <div style={{ height: 600, width: '100%' }}>
            <Typography variant="button" sx={{ fontSize: 14, color: 'gray' }}>Microservicios / Parametros: <span style={{ fontWeight: 'bold' }}>{pDescInterfaz}</span> </Typography>
            <EscoDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                getRowId={getRowId}
                pEditar={true}
                pAgregar={false}
                pMuestraToolbar={true}
            >
                <ConfigMicroservicioParamView setData={setData} pInit={init} />
            </EscoDataGrid>
        </div>
    );
}
